import React, { useState } from "react";
import "./EditableCardTable.scss";
import PaginationComponentHorizontalGrid from "../GridViewSellTrade/PaginationComponentHorizontal";
import translations from '../../utils/language/translations.json'
import { useTranslation } from 'react-i18next';
const EditableCardTable = ({ cards, setCards }) => {
  const [isVisible, setIsVisible] = useState(true); // Collapsible toggle
  const [priceChanged, setPriceChanged] = useState(
    cards.map(() => ({ Price: false, EstimateValue: false }))
  ); const [sortValue, setSortValue] = useState(""); // Sorting state
  const [currentPage, setCurrentPage] = useState(1); // Pagination state
  const [itemsPerPage, setItemsPerPage] = useState(5); // Items per page

  // Sorting function


  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.Export[key][currentLang];
  function handleSort(e) {
    setSortValue(e.target.value);
    setCurrentPage(1); // Reset to first page after sorting
  }

  const sortedData = [...cards].sort((a, b) => {
    switch (sortValue) {
      case "priceAsc":
        return (a.Price || 0) - (b.Price || 0);
      case "priceDesc":
        return (b.Price || 0) - (a.Price || 0);
      case "estimateAsc":
        return (a.EstimateValue || 0) - (b.EstimateValue || 0);
      case "estimateDesc":
        return (b.EstimateValue || 0) - (a.EstimateValue || 0);
      case "playerNameAsc":
        return (a.Name || "").localeCompare(b.Name || "");
      case "playerNameDesc":
        return (b.Name || "").localeCompare(a.Name || "");
      case "cardNameAsc":
        return (a.cardName || "").localeCompare(b.cardName || "");
      case "cardNameDesc":
        return (b.cardName || "").localeCompare(a.cardName || "");
      case "insertDateAsc":
        return new Date(a.InsertDate || 0) - new Date(b.InsertDate || 0);
      case "insertDateDesc":
        return new Date(b.InsertDate || 0) - new Date(a.InsertDate || 0);
      default:
        return 0;
    }
  });

  // Pagination logic
  const totalPages = Math.ceil(sortedData.length / itemsPerPage);

  const paginatedCards = sortedData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleChange = (index, field, value) => {
    const updatedCards = [...cards];
    updatedCards[index] = { ...updatedCards[index], [field]: value };
    setCards(updatedCards);
    
    // Track changes separately for Price and EstimateValue
    const updatedChanges = [...priceChanged];
    updatedChanges[index] = { 
      ...updatedChanges[index], 
      [field]: true 
    };
    setPriceChanged(updatedChanges);
  };

  const saveCard = (index, field) => {
    console.log(`Saving ${field}:`, cards[index]);
  
    const updatedChanges = [...priceChanged];
    updatedChanges[index] = { 
      ...updatedChanges[index], 
      [field]: false 
    };
    setPriceChanged(updatedChanges);
  };

  const removeCard = (index) => {
    const updatedCards = cards.filter((_, i) => i !== index);
    setCards(updatedCards);
  };

  const saveAll = () => {
    console.log("Saving all cards:", cards);
    setPriceChanged(cards.map(() => ({ Price: false, EstimateValue: false }))); 
  };
  const DisketteSaveIcon = ({ index }) => {
    const isPriceChanged = priceChanged[index]?.Price;
    const isEstimateChanged = priceChanged[index]?.EstimateValue;
    const saved = isPriceChanged || isEstimateChanged; // Either one changed
    console.log('cards',cards)
    return (
      <button className="diskette-btn" onClick={() => saveCard(index)} title="Save">
        {saved ? <DisketteSaveBlue /> : <DisketteSaveGrey />}
      </button>
    );
  };

  const DisketteSaveBlue = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="#0613c6"
      stroke="#0613c6"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <path d="M506.513 98.709L413.291 5.486A18.73 18.73 0 00400.047 0H385.77a6.245 6.245 0 00-6.244 6.244v151.114c0 10.345-8.387 18.732-18.732 18.732H151.196c-10.345 0-18.732-8.387-18.732-18.732V6.244A6.245 6.245 0 00126.22 0H18.732C8.387 0 0 8.387 0 18.732v474.537C0 503.613 8.387 512 18.732 512h474.537c10.345 0 18.732-8.387 18.732-18.732V111.954a18.732 18.732 0 00-5.488-13.245zM400.554 410.226c0 10.345-8.387 18.732-18.732 18.732H130.178c-10.345 0-18.732-8.387-18.732-18.732V263.094c0-10.345 8.387-18.732 18.732-18.732h251.644c10.345 0 18.732 8.387 18.732 18.732v147.132z"></path>
        <path d="M176.172 126.138h159.647a6.244 6.244 0 006.244-6.244V6.244A6.245 6.245 0 00335.819 0H176.172a6.245 6.245 0 00-6.244 6.244v113.65a6.245 6.245 0 006.244 6.244zm99.174-79.868c0-10.345 8.387-18.732 18.732-18.732s18.732 8.387 18.732 18.732v33.598c0 10.345-8.387 18.732-18.732 18.732s-18.732-8.387-18.732-18.732V46.27zM318.413 317.93H193.586c-10.345 0-18.732 8.387-18.732 18.732s8.387 18.732 18.732 18.732h124.828c10.345 0 18.73-8.387 18.73-18.732s-8.386-18.732-18.731-18.732z"></path>
      </g>
    </svg>
  );
  const DisketteSaveGrey = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="#a1a1a1"
      stroke="#a1a1a1"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <path d="M506.513 98.709L413.291 5.486A18.73 18.73 0 00400.047 0H385.77a6.245 6.245 0 00-6.244 6.244v151.114c0 10.345-8.387 18.732-18.732 18.732H151.196c-10.345 0-18.732-8.387-18.732-18.732V6.244A6.245 6.245 0 00126.22 0H18.732C8.387 0 0 8.387 0 18.732v474.537C0 503.613 8.387 512 18.732 512h474.537c10.345 0 18.732-8.387 18.732-18.732V111.954a18.732 18.732 0 00-5.488-13.245zM400.554 410.226c0 10.345-8.387 18.732-18.732 18.732H130.178c-10.345 0-18.732-8.387-18.732-18.732V263.094c0-10.345 8.387-18.732 18.732-18.732h251.644c10.345 0 18.732 8.387 18.732 18.732v147.132z"></path>
        <path d="M176.172 126.138h159.647a6.244 6.244 0 006.244-6.244V6.244A6.245 6.245 0 00335.819 0H176.172a6.245 6.245 0 00-6.244 6.244v113.65a6.245 6.245 0 006.244 6.244zm99.174-79.868c0-10.345 8.387-18.732 18.732-18.732s18.732 8.387 18.732 18.732v33.598c0 10.345-8.387 18.732-18.732 18.732s-18.732-8.387-18.732-18.732V46.27zM318.413 317.93H193.586c-10.345 0-18.732 8.387-18.732 18.732s8.387 18.732 18.732 18.732h124.828c10.345 0 18.73-8.387 18.73-18.732s-8.386-18.732-18.731-18.732z"></path>
      </g>
    </svg>
  )


  function validateLabel(value, label) {
    switch (label) {
      case "IsRookie":
      return value=== 1 ? "Rookie(RC)" : null;

    case "IsPatch":
      return value=== 1 ? "Patch" : null;

    case "IsJersey":
      return value=== 1 ? "Jersey" : null;

    case "IsAuto":
      return value=== 1 ? "Auto" : false;

    case "IsTribute":
      return value === 1 ? "Tribute" : false;

    case "Numbered":
      return value ? `${value}` : false;

    }
  }
  //&& validateLabel(value, label)
  const renderAttributeSquare = (value,label) => {
  
    if(value === 1)
    return  (
      <button className="pill">{`${validateLabel(value, label)}`}</button>
    )
  };


  const renderAttributeGrading = (GradingCompany, Grade) => {
    if (!GradingCompany) return null;
  
    const getGradingCompanyClass = (GradingCompany) => {
      switch (GradingCompany.toLowerCase()) {
        case "psa":
          return "psa";
        case "bgs":
          return "bgs";
        case "mnt":
          return "mnt";
        case "mint":
          return "mint";
        case "sgc":
          return "sgc";
        case "cgc":
          return "cgc";
        case "hga":
          return "hga";
        case "ksa":
          return "ksa";
        case "fcb":
          return "fcb";
        default:
          return ""; // Default class for unlisted grading companies
      }
    };
  
    return (
      <div
        className="line-item"
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <p className="planText">
          <button className={`patch-grading ${getGradingCompanyClass(GradingCompany)}`}>
            {`${GradingCompany} ${Grade}`}
          </button>
        </p>
      </div>
    );
  };


  return (
    <div className="editable-card-table">
      <button className="btn-baseBlue" onClick={() => setIsVisible(!isVisible)}>
        {isVisible ? `🔽 ${t("Hide Card Editor")} `: `▶ ${t("Show Card Editor")}`}
      </button>

      {isVisible && (
        <div className="table-container">
         <h2>{t("Edit Card Values")}</h2>
<div style={{ marginBottom: "20px",width:'fit-content' }}>
  {/* <label>{t("Sort by")}: </label> */}
  <select value={sortValue} onChange={handleSort}>
    <option value="">{t("Order By")}</option>
    <option value="priceAsc">{t("Price (Low to High)")}</option>
    <option value="priceDesc">{t("Price (High to Low)")}</option>
    <option value="estimateAsc">{t("Estimate Value (Low to High)")}</option>
    <option value="estimateDesc">{t("Estimate Value (High to Low)")}</option>
    <option value="playerNameAsc">{t("Player Name (A-Z)")}</option>
    <option value="playerNameDesc">{t("Player Name (Z-A)")}</option>
    <option value="cardNameAsc">{t("Card Name (A-Z)")}</option>
    <option value="cardNameDesc">{t("Card Name (Z-A)")}</option>
    <option value="insertDateAsc">{t("Added Date (Oldest to Newest)")}</option>
    <option value="insertDateDesc">{t("Added Date (Newest to Oldest)")}</option>
  </select>
</div>
        {cards.length>5 && <PaginationComponentHorizontalGrid
  totalPages={totalPages}
  currentPage={currentPage}
  setCurrentPage={setCurrentPage}
  itemsPerPage={itemsPerPage}
  setItemsPerPage={setItemsPerPage}
/>}
          <table className="card-table">
          <colgroup>
    <col style={{ width: "5%" }} />   {/* # */}
    <col style={{ width: "12%" }} />  {/* Image */}
    <col style={{ width: "35%" }} />  {/* Card Details */}
    <col style={{ width: "10%" }} />  {/* Condition */}
    <col style={{ width: "10%" }} />  {/* Est Value */}
    <col style={{ width: "8%" }} />  {/* Price */}
   
   
  </colgroup>
            <thead>
              <tr>
              <th>#</th>
<th>Image</th>
<th>{t("Card Details")}</th>
<th>{t("Condition")}</th>
<th>{t("Est Value ($)")}</th>



              </tr>
            </thead>
            <tbody>
              {paginatedCards.map((card, index) => (
                <tr key={index}>
                  <td>{index+1}</td>
                  <td>
                    <img
                      src={card.ImageFront|| card.Image}
                      alt="Card"
                      className="card-image"
                    />
                  </td>
                  {/* <td> {card.SearchTitle}</td> */}
                  <td className="card-details">
                  <h4 style={{ fontSize: "1rem", fontWeight: "500", color: "#ddd"}}>{card.Name}   {card.NumberBehind && (<span>#{card.NumberBehind}</span>)}
                  <br />{card.SetName}  <br />{card.cardName} - {card.variationName}  </h4>
                  <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', flexWrap: 'wrap' }}>
                {renderAttributeSquare(card.IsRookie, "IsRookie")}
                {renderAttributeSquare(card.IsPatch, "IsPatch")}
                {renderAttributeSquare(card.IsJersey, "IsJersey")}
                {renderAttributeSquare(card.IsAuto, "IsAuto")}
             
                {parseInt(card.Numbered) > 0 &&
                  renderAttributeSquare("/" + card.Numbered, "Numbered")}
              </div>
                </td>

                <td>
  {card.Graded===0 ||card.Graded===false ? (
    <>
      <p>{card.ConditionCard}</p>
    </>
  ) : (
    <>
      {renderAttributeGrading(card.GradeCompany,card.Grade)}
    </>
  )}
</td>


                  {/* <td>
                    <input
                      type="number"
                      value={card.EstimateValue}
                      onChange={(e) => handleChange(index, "EstimateValue", e.target.value)}
                      className="input-box"
                      id={`estimate-input-${index}`}
                      onClick={(e) => e.target.select()}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9.]/g, ""); // Allow only numbers and decimals
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && priceChanged[index]) {
                          saveCard(index);
                          const nextInput = document.querySelector(`#price-input-${index}`);
                          if (nextInput) {
                            nextInput.focus();
                            nextInput.select();
                          }
                        } else if (e.key === "Tab") {
                          e.preventDefault();
                          const nextInput = document.querySelector(`#price-input-${index}`);
                          if (nextInput) {
                            nextInput.focus();
                            nextInput.select();
                          }
                        }
                      }}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      value={card.Price}
                      onChange={(e) => handleChange(index, "Price", e.target.value)}
                      className="input-box"
                      id={`price-input-${index}`}
                      onClick={(e) => e.target.select()}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9.]/g, ""); // Allow only numbers and decimals
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && priceChanged[index]) {
                          saveCard(index);
                          const nextInput = document.querySelector(`#estimate-input-${index + 1}`);
                          if (nextInput) {
                            nextInput.focus();
                            nextInput.select();
                          }
                        } else if (e.key === "Tab") {
                          e.preventDefault();
                          const nextInput = document.querySelector(`#estimate-input-${index + 1}`);
                          if (nextInput) {
                            nextInput.focus();
                            nextInput.select();
                          }
                        }
                      }}
                    />
                  </td> */}

                  {/* Est Value & Price in separate cells for desktop */}
<td className="value-price-cell">
  <div className="value-price-wrapper">
    <div className="estimate">
      <label>{t("Est Value ($)")}</label>
      <input
        type="number"
        value={card.EstimateValue}
        onChange={(e) => handleChange(index, "EstimateValue", e.target.value)}
        className="input-box"
        id={`estimate-input-${index}`}
        onClick={(e) => e.target.select()}
        onInput={(e) => {
          e.target.value = e.target.value.replace(/[^0-9.]/g, "");
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" && priceChanged[index]) {
            saveCard(index);
            const nextInput = document.querySelector(`#price-input-${index}`);
            if (nextInput) {
              nextInput.focus();
              nextInput.select();
            }
          } else if (e.key === "Tab") {
            e.preventDefault();
            const nextInput = document.querySelector(`#price-input-${index}`);
            if (nextInput) {
              nextInput.focus();
              nextInput.select();
            }
          }
        }}
      />
    </div>
    <div className="price">
      <label>{t("Price ($)")}</label>
      <input
        type="number"
        value={card.Price}
        onChange={(e) => handleChange(index, "Price", e.target.value)}
        className="input-box"
        id={`price-input-${index}`}
        onClick={(e) => e.target.select()}
        onInput={(e) => {
          e.target.value = e.target.value.replace(/[^0-9.]/g, "");
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" && priceChanged[index]) {
            saveCard(index);
            const nextInput = document.querySelector(`#estimate-input-${index + 1}`);
            if (nextInput) {
              nextInput.focus();
              nextInput.select();
            }
          } else if (e.key === "Tab") {
            e.preventDefault();
            const nextInput = document.querySelector(`#estimate-input-${index + 1}`);
            if (nextInput) {
              nextInput.focus();
              nextInput.select();
            }
          }
        }}       
      />
    </div>
  </div>
</td>

                  {/* <td className="action-td">
                    <DisketteSaveIcon saved={priceChanged[index]} index={index} />
                
                  </td> */}
                  <td>   <button className="action-btn remove-btn" onClick={() => removeCard(index)}>
                      ❌
                    </button></td>
                </tr>
              ))}
            </tbody>
          </table>

          <button className="btn-baseBlue" style={{marginTop:'20px'}} onClick={saveAll}>{t("Update Collage")}</button>
        </div>
      )}
    </div>
  );
};

export default EditableCardTable;
